<template>
  <div class="d-sm-flex fill-height" style="overflow: hidden auto;">
    <v-list max-width="390px" class="flex-shrink-0">
      <v-subheader>{{ meetingCompanyName }}</v-subheader>
      <v-subheader>Типы документов</v-subheader>
      <v-list-item-group v-model="selected" color="primary darken-3">
        <v-list-item
          v-for="doc in meetingdocs"
          :key="doc.name"
          :color="doc.is_approved === false ? 'error' : ''"
          :disabled="doc.deny_upload === true"
        >
          <v-list-item-content>
            <v-list-item-title>{{ doc.title }}</v-list-item-title>
            <v-list-item-subtitle
              v-if="doc.subtitle"
              class="font--title-small"
              :class="parseColor(doc.subtitle.color)"
              v-text="doc.subtitle.text"
            ></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar v-if="doc.is_approved === false">
            <v-icon color="error">mdi-alert-circle-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-avatar v-else-if="doc.is_approved === true">
            <v-icon color="success">mdi-check-circle-outline</v-icon>
          </v-list-item-avatar>

          <template v-if="doc.sended">
            <v-list-item-avatar v-if="doc.deny_upload">
              <v-icon color="accent">mdi-check-circle-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar v-else-if="doc.is_approved === null">
              <v-icon color="warning">mdi-clock-time-eight-outline</v-icon>
            </v-list-item-avatar>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-divider class="d-none d-sm-block" vertical></v-divider>
    <v-container fill-height fluid>
      <v-row class="align-self-start">
        <v-col class="pa-0" cols="12">
          <v-alert class="mb-0" v-if="interruptReason" tile dense type="error" style="overflow-wrap: anywhere">{{
            interruptReason
          }}</v-alert>
          <v-alert v-if="show_main_wait" tile dense type="warning">Ожидается загрузка документов</v-alert>
        </v-col>

        <v-col v-if="selected >= 0" :key="selected" cols="12">
          <h4 v-if="!show_success && !show_wait" class="font font--color_light mb-2">Загрузите все документы</h4>
          <v-alert v-if="show_comment" type="error" color="red lighten-2">{{ comment }}</v-alert>
          <v-alert v-if="show_success" type="success" color="green lighten-2">Документы прошли проверку</v-alert>
          <v-alert v-if="show_wait" icon="mdi-timer-sand-empty" color="yellow lighten-4">
            Документы отправлены на проверку
          </v-alert>

          <v-checkbox
            v-if="name === 'statute'"
            v-model="is_typical_statute"
            class="mb-8"
            label="Типовой устав"
            hide-details="auto"
            dense
          ></v-checkbox>

          <AttachmentUpload
            v-if="(name === 'statute' && !is_typical_statute) || name !== 'statute'"
            multi
            :value="files"
            :name="name"
            :allowed-types="allowed_extensions"
            @attachment-file-add="addFiles"
            @attachment-file-remove="handleDeleteFile"
            :context-id="currentMeetingId"
            :context-name="attachmentMetadata.contextName"
            :group-name="group_name"
          >
            <template #list-prepend>
              <h4 v-if="files && files.length > 0" class="font font--color_light my-4">Загруженные документы:</h4>
            </template>
          </AttachmentUpload>
        </v-col>
      </v-row>
      <v-row v-show="selected === undefined" justify="center" class="align-self-stretch">
        <span class="headline blue-grey--text text--lighten-2 font-weight-light">Выберите тип документа</span>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import AttachmentUpload from "@/components/common/AttachmentUpload";

export default {
  components: { AttachmentUpload },

  data() {
    return {
      selected: undefined,
      attachmentMetadata: {
        contextName: "app",
      },
    };
  },
  computed: {
    ...mapState("meeting", ["currentMeetingId"]),
    ...mapGetters("meeting", ["meetingdocs", "isAllMeetingDocsSended", "meetingCompanyName", "interruptReason"]),

    files() {
      return this.meetingdocs[this.selected]?.docs || [];
    },
    name() {
      return this.meetingdocs[this.selected]?.name;
    },
    group_name() {
      return this.meetingdocs[this.selected]?.group_name;
    },
    allowed_extensions() {
      return this.meetingdocs[this.selected]?.properties?.allowed_extensions;
    },
    comment() {
      return this.meetingdocs[this.selected]?.comment;
    },
    show_comment() {
      return this.meetingdocs[this.selected]?.is_approved === false;
    },
    show_success() {
      return this.meetingdocs[this.selected]?.is_approved === true;
    },
    show_wait() {
      return this.sended && this.meetingdocs[this.selected]?.is_approved === null;
    },
    sended() {
      return this.meetingdocs[this.selected]?.sended;
    },
    isAllSended() {
      return this.meetingdocs.every((doc) => doc.sended);
    },
    show_main_wait() {
      return !this.isAllMeetingDocsSended;
    },
    is_typical_statute: {
      get() {
        return this.$store.state.meeting.isTypicalStatute;
      },

      set(value) {
        this.$store.commit("meeting/setTypicalStatute", value);
      },
    },
  },

  methods: {
    ...mapMutations("meeting", ["setAccountOpenStep", "setMeetingDocsFor"]),

    async addFiles({ updatedList, isLastUploaded }) {
      if (isLastUploaded) {
        this.setMeetingDocsFor({ index: this.selected, docs: updatedList });
      }
    },

    handleDeleteFile({ updatedList }) {
      this.setMeetingDocsFor({ index: this.selected, docs: updatedList });
    },

    parseColor(color) {
      if (!color) return undefined;

      const [colorName, colorModifier] = color
        .toString()
        .trim()
        .split(" ", 2);
      if (!colorName) return undefined;

      let classes = {
        [colorName + "--text"]: true,
      };

      if (colorModifier) {
        classes["text--" + colorModifier] = true;
      }

      return classes;
    },
  },
};
</script>
